import { do_interaction } from './Analytics_Custom';
export function selectExportPDF() {
    do_interaction(`DPH CDI|COMP, EXPORT, PDF`);
}
export function selectExportCSV() {
    do_interaction(`DPH CDI|COMP, EXPORT, CSV`);
}
export function selectSearch() {
    do_interaction(`DPH CDI|COMP, SEARCH`);
}
export function selectIndicatorDefinitions() {
    do_interaction(`DPH CDI|NAVDEF`);
}
export function selectSubmit(location) {
    do_interaction(`DPH CDI|COMP, LOCATION, ${location}`);
}
